import { PartialRecord } from "@base/util/TypeUtil";
import { IProjectCheckError, IProjectCheckErrorFieldGroup, ProjectCheckErrorType } from "@biz/projectCalculation/ProjectDefinitions";

export type IErrorMap<ID extends string | number | symbol = string | number | symbol> = PartialRecord<ID, { text: string, type: ProjectCheckErrorType }>;
export type IFieldErrorMap<ID extends string | number | symbol = string | number | symbol> = PartialRecord<ID, IErrorMap>;

export class FieldErrorMap {
  static set<T extends string>(map: IFieldErrorMap<T>, object: T, field: string, error: string, type: ProjectCheckErrorType): void {
    let m: IErrorMap | undefined = map[object];
    if (!m) {
      m = {};
      map[object] = m;
    }
    m[field] = { text: error, type };
  }

  static errorMapFromErrors(errors: IProjectCheckError[] | undefined): IFieldErrorMap<IProjectCheckErrorFieldGroup> {
    if (!errors)
      return {};
    const errorMap: IFieldErrorMap<IProjectCheckErrorFieldGroup> = {};
    for (const error of errors) {
      for (const field of error.fields) {
        FieldErrorMap.set(errorMap, field.group, field.id, error.text, error.type);
      }
    }
    return errorMap;
  }
}
